import { List as MuiList, ListProps as MuiListProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledList = styled(MuiList)<MuiListProps>(
  ({ theme: { palette, spacing, colors } }) => ({
    padding: '0',

    /** Menu Item Button */
    '& .MuiListItemButton-root': {
      padding: spacing(1.7, 2.4),
      color: palette.secondary.contrastText,
      textDecoration: 'none',

      '&:hover': {
        backgroundColor: colors.menuItemHover,
      },

      '&.Mui-selected': {
        backgroundColor: colors.menuItemSelected,
      },
    },

    /** Menu Item Button Icon */
    '& .MuiListItemIcon-root': {
      minWidth: '0',
      marginRight: spacing(0.8),
      color: palette.secondary.contrastText,
    },

    /** Menu Item Text */
    '& .MuiListItemText-root': {
      margin: '0',

      '& .MuiTypography-root': {
        color: palette.secondary.contrastText,
      },
    },

    '& .MuiCollapse-wrapper .MuiListItemButton-root': {
      position: 'relative',
      paddingLeft: spacing(5.2),

      /** BORDER LEFT */
      '&::before': {
        content: '""',
        position: 'absolute',
        width: spacing(0.1),
        height: '100%',
        top: '0',
        left: spacing(3.6),
        backgroundColor: colors.menuSubItemSelected,
      },

      /** MASK TO MATCH THE DESIGN */
      '&.Mui-selected::after': {
        content: '""',
        position: 'absolute',
        width: spacing(3.6),
        height: '100%',
        top: '0',
        left: '0',
        backgroundColor: colors.sideBarMenu,
      },

      '&:hover': {
        backgroundColor: colors.menuSubItemHover,

        '&::before': {
          backgroundColor: colors.menuSubItemSelected,
        },
      },

      '&.Mui-selected': {
        backgroundColor: colors.menuSubItemSelected,

        '&::before': {
          backgroundColor: palette.common.white,
        },
      },
    },
  })
);
